import styled from '@emotion/styled';
import { Box, Button, Modal, Typography } from '@mui/material';
import { ModalContent, Title, CloseModalIcon, CloseModalButton } from './edit-modal.styles';

export { ModalContent, CloseModalIcon, CloseModalButton };

export const StyledModal = styled(Modal)({
  width: '428px',
  height: '236px',
  marginTop: 'calc(50vh - 118px)',
  marginLeft: 'calc(50% - 214px)'
});

export const CloseButton = styled(CloseModalButton)({
  marginTop: '-2px',
  marginLeft: '305px',
  marginBottom: '-30px'
});

export const PopupTitle = styled(Title)({
  fontSize: '20px'
});

export const Text = styled(Typography)({
  textAlign: 'center',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  width: '400px',
  marginLeft: '-55px',
  marginTop: '25px'
});

export const ButtonsContainer = styled(Box)({
  width: '350px',
  marginLeft: '-20px',
  marginTop: '40px'
});

export const QuitEditingButton = styled(Button)({
  color: '#3F51B5',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '155px',
  height: '44px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  }
});

export const KeepEditingButton = styled(Button)({
  color: 'white',
  background: '#5F65F6',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '155px',
  height: '44px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#5F7EF5'
  },
  '&.Mui-disabled': {
    backgroundColor: '#ACADCF',
    color: '#FFF'
  },
  marginLeft: '20px'
});

export const BackdropStyles = {
  style: {
    background: 'transparent'
  }
};
